import { makeStyles } from '@material-ui/core'

export const useStyles = makeStyles(theme => ({
  // =========================================================================
  // ## Layout & Containers (Box/Geral)
  // =========================================================================

  boxContainer: {
    height: '100%'
  },
  boxContent: {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'space-between',
    padding: '8px 16px !important',
    borderRadius: 8,
    maxHeight: '80px',
    backgroundColor:
      theme.palette.type === 'dark'
        ? theme.palette.dark_400.main
        : theme.palette.gray_100.main,
    border:
      theme.palette.type === 'dark'
        ? `1px solid ${theme.palette.dark_stroke.main}`
        : `1px solid ${theme.palette.gray_stroke.main}`
  },
  boxForm: {
    display: 'flex',
    flexDirection: 'column',
    justifyContent: 'space-between',
    gap: '8px'
  },
  boxInput: {
    display: 'flex',
    flexDirection: 'column',
    gap: '8px'
  },
  boxInputWrapper: {
    display: 'flex',
    justifyContent: 'center',
    gap: '8px',
    height: '100%'
  },
  inputWrapper: {
    width: '30%',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center'
  },
  iconWrapper: {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center'
  },
  iconWrapperText: {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    gap: '8px',
    fontSize: '1rem',
    '& strong': {
      color:
        theme.palette.type === 'dark'
          ? theme.palette.dark_50.main
          : theme.palette.gray_400.main
    }
  },
  buttonsActions: {
    display: 'flex',
    justifyContent: 'flex-end',
    gap: '8px'
  },

  // =========================================================================
  // ## Anexos (Attachments) e Pré-visualização
  // =========================================================================

  attachmentContainer: {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'flex-end',
    gap: '8px'
  },
  buttonsAttachmentFile: {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    gap: '8px',
    width: '100%',
    height: '90px',
    backgroundColor:
      theme.palette.type === 'dark'
        ? theme.palette.dark_400.main
        : theme.palette.gray_100.main,
    border:
      theme.palette.type === 'dark'
        ? '1px solid' + theme.palette.dark_stroke.main
        : '1px solid' + theme.palette.gray_stroke.main,
    borderRadius: '8px',
    padding: '16px'
  },
  buttonsBoxAttachment: {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    gap: '8px'
  },
  buttonsAttachment: {
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center',
    justifyContent: 'flex-end',
    gap: '8px'
  },
  attachmentPreviewContainer: {
    display: 'flex',
    alignItems: 'center'
  },
  attachmentPreviewImage: {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    maxWidth: 100,
    maxHeight: 100,
    padding: '8px',
    objectFit: 'contain',
    borderRadius: '8px',
    height: 'auto'
  },
  attachmentNotFile: {
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center',
    justifyContent: 'center',
    gap: '8px',
    fontStyle: 'italic'
  },

  // =========================================================================
  // ## Botões
  // =========================================================================

  buttonFile: {
    '& .MuiButton-label': {
      display: 'flex',
      gap: '8px'
    },
    backgroundColor: theme.palette.blue_300.main,
    color: theme.palette.white_100.main,
    height: 35,
    borderRadius: 8,
    maxWidth: 250,
    '&:hover': {
      backgroundColor: theme.palette.green_200.main
    },
    '& span': {
      overflow: 'hidden',
      textOverflow: 'ellipsis',
      whiteSpace: 'nowrap'
    }
  },
  iconButtonDelete: {
    border: 0,
    padding: '0',
    backgroundColor: 'transparent',
    '&:hover': {
      backgroundColor: 'transparent'
    },
    '& svg': {
      color: theme.palette.red_100.main
    }
  },
  buttonDeleteOption: {
    display: 'flex',
    justifyContent: 'flex-start',
    gap: '8px',
    width: '100%'
  },
  deleteButton: {
    color: theme.palette.red_100.main,
    height: 35,
    width: 50,
    borderRadius: 8,
    '&:hover': {
      backgroundColor: theme.palette.red_100.main,
      color: theme.palette.white_100.main
    }
  },

  // =========================================================================
  // ## Diálogos / Modais
  // =========================================================================

  dialogTitle: {
    color: theme.palette.blue_300.main,
    backgroundColor:
      theme.palette.type === 'dark'
        ? theme.palette.dark_700.main
        : theme.palette.white_100.main,
    padding: '12px 24px'
  },
    dialogTitleActiveOption: {
    color: theme.palette.blue_300.main,
  },
  dialogTitleActiveDepartment:{
    color: theme.palette.blue_300.main,
  },
  dialogActions: {
    padding: '12px 24px'
  },
  dialogContentPreview: {
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
    overflow: 'hidden'
  },
  imagePreview: {
    maxWidth: '100%',
    maxHeight: '50vh',
    objectFit: 'contain'
  },

  // =========================================================================
  // ## Switch / Toggle
  // =========================================================================

  // Originalmente 'inputSwitch' estava duplicado, mantive o mais recente/específico
  inputSwitch: {
    display: 'flex',
    alignItems: 'center',
    marginTop: '32px' // Usando o valor mais recente
  },
  switchContainer: {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'flex-end',
    gap: '8px',
    width: '100%'
  },
  switchText: {
    fontWeight: 500,
    fontSize: '.875rem',
    color:
      theme.palette.type === 'dark'
        ? theme.palette.white_100.main
        : theme.palette.gray_400.main
  },
  // Classes para customização interna do MuiSwitch (necessárias para referências)
  checked: {},
  switchBase: {},
  disabled: {},
  track: {},

  customSwitchRoot: {
    // Estilo para o 'switchBase' (Contêiner do thumb)
    '& .MuiSwitch-switchBase': {
      // Cor do thumb (off)
      color:
        theme.palette.type === 'dark'
          ? theme.palette.white_100.main
          : theme.palette.gray_400.main,

      // Estilo da track (fundo) quando OFF
      '& + .MuiSwitch-track': {
        border: 'none',
        backgroundColor:
          theme.palette.type === 'dark'
            ? theme.palette.gray_100.main
            : theme.palette.gray_300.main,
        opacity: 1
      },

      // Estilo do thumb quando ON (checked)
      '&$checked': {
        color:
          theme.palette.type === 'dark'
            ? theme.palette.blue_300.main
            : theme.palette.blue_300.main
      },

      // Estilo do thumb quando desativado (disabled)
      '&$disabled': {
        color:
          theme.palette.type === 'dark'
            ? theme.palette.blue_300.main
            : theme.palette.blue_300.main
      },

      // Estilo da track (fundo) quando ON (checked)
      '&$checked + .MuiSwitch-track': {
        backgroundColor:
          theme.palette.type === 'dark'
            ? theme.palette.gray_100.main
            : theme.palette.gray_300.main,
        opacity: 1
      }
    },

    // Estilo padrão para a 'track' (o fundo)
    '& .MuiSwitch-track': {
      backgroundColor: theme.palette.gray_100.main,
      borderRadius: 22 / 2
    }
  },

  // =========================================================================
  // ## Ajuda e Informação (Help/Info)
  // =========================================================================

  boxContentHelp: {
    height: '100%',
    display: 'flex',
    alignItems: 'flex-end'
  },
  boxHelpContainer: {
    border:
      theme.palette.type === 'dark'
        ? '1px solid' + theme.palette.dark_stroke.main
        : '1px solid' + theme.palette.gray_stroke.main,
    borderRadius: 16,
    padding: '8px 12px'
  },
  boxHelpContainerActiveOption: {
    border: '1px solid' + theme.palette.blue_300.main,
    backgroundColor: theme.palette.blue_300.main + '1A', // Fundo com transparência
    // boxShadow: `0 0 8px ${theme.palette.blue_300.main + '40'}`, // Sombra suave
  },
  boxHelpContainerActiveDepartment:{
    border: '1px solid' + theme.palette.blue_300.main,
    backgroundColor: theme.palette.blue_300.main + '1A', // Fundo com transparência
    // boxShadow: `0 0 8px ${theme.palette.green_200.main + '40'}`, // Sombra suave
  },

  boxHelp: {
    display: 'flex',
    flexDirection: 'column',
    gap: '8px',
    backgroundColor:
      theme.palette.type === 'dark'
        ? theme.palette.dark_700.main
        : theme.palette.white_100.main,
    color: theme.palette.white_100.main
  },
  boxHelpContent: {
    display: 'flex',
    flexDirection: 'column',
    gap: '8px'
  },
  helpTitle: {
    display: 'flex',
    flexDirection: 'column',
    // alignItems: 'center',
    // justifyContent: 'space-between',
    // backgroundColor:
    //   theme.palette.type === 'dark'
    //     ? theme.palette.blue_300.main
    //     : theme.palette.white_100.main,
    color:
      theme.palette.type === 'dark'
        ? theme.palette.dark_50.main
        : theme.palette.blue_300.main,
    // padding: '8px',
    gap: '8px',
    fontWeight: '600'
  },
  helpTitleText: {
    display: 'flex',
    alignItems: 'center',
    gap: '8px',
    fontSize: '1rem'
  },
  helpText: {
    margin: '8px 0',
    fontSize: '.875rem',
    color:
      theme.palette.type === 'dark'
        ? theme.palette.dark_50.main
        : theme.palette.gray_400.main, // Há uma inconsistência aqui, pois boxHelp define cor de fundo escura (dark_700) e text white, mas aqui define dark_50/white_100. Mantive como estava no original, mas note a possível inconsistência de cor.
    '& p': {
      margin: '2px 0 8px'
    }
  },
  helpList: {
    padding: '0 24px',
    margin: '0 14px'
  },
  boxInfoHelp: {
    backgroundColor:
      theme.palette.type === 'dark'
        ? theme.palette.dark_400.main
        : theme.palette.gray_100.main,
    padding: '8px 16px',
    border:
      theme.palette.type === 'dark'
        ? '1px solid' + theme.palette.dark_stroke.main
        : '1px solid' + theme.palette.gray_stroke.main,
    borderRadius: 8,
    color:
      theme.palette.type === 'dark'
        ? theme.palette.dark_50.main
        : theme.palette.gray_400.main
  },
  infoBox: {
    // width: '70%', // Comentário original mantido
    '& span': {
      color:
        theme.palette.type === 'dark'
          ? theme.palette.dark_50.main
          : theme.palette.gray_400.main
    }
  },

  // =========================================================================
  // ## Badges (Tags/Rótulos)
  // =========================================================================

  badge: {
    padding: '2px 4px',
    backgroundColor:
      theme.palette.type === 'dark'
        ? theme.palette.blue_300.main
        : theme.palette.blue_300.main,
    color:
      theme.palette.type === 'dark'
        ? theme.palette.white_100.main
        : theme.palette.white_100.main,
    borderRadius: 4,
    margin: '0 4px'
  },
  activeBadge: {
    backgroundColor: theme.palette.blue_300.main,
    color: theme.palette.white_100.main,
    padding: '2px 8px',
    borderRadius: '16px',
    fontSize: '0.7rem',
    fontWeight: 'bold',
    textTransform: 'uppercase'
  }
}))
